import styled from 'styled-components';

import { DotLoadingIndicator } from '@xing-com/dot-loading-indicator';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
`;

export const FullPageDotLoading: React.FC = () => {
  return (
    <Container data-testid="full-page-dot-loading">
      <DotLoadingIndicator />
    </Container>
  );
};
